export enum CompanyDouble {
  'New' = 'ikontyres',
  'Old' = 'nokian',
}
